import type { ICookie, ICookieGetOpts } from 'cookie-universal'
import Cookie from 'cookie-universal'
import { defineNuxtPlugin } from 'nuxt/app'

/**
 * Переорпеделяем типы для метода get
 * Нужно для того, что бы get возвращал тип T, а не ANY
 */
type ICookieExtended = Omit<ICookie, 'get'> & {
  get: <T = unknown>(name: string, opts?: ICookieGetOpts) => T
}

export default defineNuxtPlugin(() => {
  const cookies: ICookieExtended = Cookie()

  return {
    provide: {
      cookies,
    },
  }
})
